import { fetchCollectionContents } from '@/utils/files';

export const classes = {
  overlay:
    'flex h-full min-h-0 w-[80vw] max-w-[1550px] overflow-hidden bg-drawer-mesh bg-no-repeat dark:bg-drawer-mesh-dark',
  overlayWide: 'w-[92vw] max-w-[2400px]',
  controls:
    'fixed top-[14px] right-5 z-[1400] flex flex-col items-center gap-[13px]',
  closeButton:
    'size-[38px] rounded-[11px] bg-black/30 text-white backdrop-blur-[4px] hover:bg-black/40',
  openButton:
    'size-[38px] rounded-[11px] bg-grad text-white shadow-orange hover:bg-grad dark:bg-grad-dark dark:hover:bg-grad-dark',
  grid: 'flex grow min-h-0 overflow-hidden',
};

export async function fetchCollectionData(collectionId: number) {
  // TODO: fetch more if pagination.pageCount > 1
  const data = await fetchCollectionContents(collectionId);
  return {
    files: data.files.results,
    fileCollections: data.fileCollections.results,
  };
}
